export default (function (a, b, c) {
  return Math.max(b || 0, Math.min(a, c || 1));
});